import { getFromStorage, setToStorage } from './expirable-local-storage';

const SEARCH_HISTORY_KEY = 'search-history';
const searchHistoryFromStorage = getFromStorage<string>({ key: SEARCH_HISTORY_KEY });
export const searchHistory = searchHistoryFromStorage ? (JSON.parse(searchHistoryFromStorage) as string[]) : [];
export const getSearchHistory = () => searchHistory;
export const setSearchHistory = (queries: string[]) => {
  setToStorage({ key: SEARCH_HISTORY_KEY, value: JSON.stringify([...new Set(queries)].slice(0, 5)), expirationSeconds: -1 });
};
export const addSearchHistory = (query: string) => {
  searchHistory.unshift(query);
  setToStorage({ key: SEARCH_HISTORY_KEY, value: JSON.stringify([...new Set(searchHistory)].slice(0, 5)), expirationSeconds: -1 });
};
